(() => {
  const mount=()=>document.querySelectorAll('yr-rose-product:not(.yr-kit-standalone)').forEach(page=>{
    if(page.dataset.mobileLayoutReady)return;
    page.dataset.mobileLayoutReady='true';
    const header=document.querySelector('#header-component');if(!header)return;
    const measure=()=>{
      if(!page.isConnected){observer.disconnect();window.removeEventListener('resize',measure);return;}
      const mobile=matchMedia('(max-width:749px)').matches;
      const top=page.getBoundingClientRect().top+window.scrollY;
      const height=header.getBoundingClientRect().height;
      page.style.setProperty('--yr-header-overlap',mobile?Math.max(0,height-top)+'px':'0px');
    };
    const observer=new ResizeObserver(measure);observer.observe(header);
    window.addEventListener('resize',measure);measure();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
  document.addEventListener('shopify:section:load',mount);
})();
